<p-panel header="{{ 'invoice_details' | translate }}" [toggleable]="false" [collapsed]="false" [style]="{'margin-bottom':'10px'}">
    <app-loader *ngIf="!isDataReady"></app-loader>    
    <div class="ui-g"  *ngIf="isDataReady">
        <div class="ui-sm-12 ui-md-12 ui-lg-10 ui-xl-8">
            <form [formGroup]="invoiceDetailsForm" (ngSubmit)="onSubmit()">

                <span class="ui-float-label" style="margin-bottom: 20px; margin-top: 10px;">
                    <input id="company_name-input" name="company_name" type="text" pInputText style="width: 100%;" formControlName="company_name"> 
                    <label for="company_name-input">{{ 'company_name' | translate }}</label>
                </span>

                <span class="ui-float-label" style="margin-bottom: 20px;">
                    <input id="company_address-input" name="company_address" type="text" pInputText style="width: 100%;" formControlName="company_address"> 
                    <label for="company_address-input">{{ 'company_address' | translate }}</label>
                </span>

                <span class="ui-float-label" style="margin-bottom: 20px;">
                    <input id="company_contact-input" name="company_contact" type="text" pInputText style="width: 100%;" formControlName="company_contact"> 
                    <label for="company_contact-input">{{ 'company_contact' | translate }}</label>
                </span>

                <span class="ui-float-label" style="margin-bottom: 20px;">
                    <input id="company_web-input" name="company_web" type="text" pInputText style="width: 100%;" formControlName="company_web"> 
                    <label for="company_web-input">{{ 'company_web_contact' | translate }}</label>
                </span>

                <span class="ui-float-label" style="margin-bottom: 20px;">
                    <input id="company_nip-input" name="company_nip" type="text" pInputText style="width: 100%;" formControlName="company_nip"> 
                    <label for="company_nip-input">{{ 'tax_number' | translate }}</label>
                </span>

                <span class="ui-float-label" style="margin-bottom: 20px;">
                    <input id="company_bank-input" name="company_bank" type="text" pInputText style="width: 100%;" formControlName="company_bank"> 
                    <label for="company_bank-input">{{ 'bank_name' | translate }}</label>
                </span>
 
                <span class="ui-float-label" style="margin-bottom: 20px;">
                    <input id="company_account-input" name="company_account" type="text" pInputText style="width: 100%;" formControlName="company_account"> 
                    <label for="company_account-input">{{ 'bank_account' | translate }}</label>
                </span>

                <span class="ui-float-label" style="margin-bottom: 20px;">
                    <input id="company_place-input" name="company_place" type="text" pInputText style="width: 100%;" formControlName="company_place"> 
                    <label for="company_place-input">{{ 'invoice_issued_place' | translate }}</label>
                </span>

                <span class="ui-float-label" style="margin-bottom: 20px;">
                    <input id="seller_name-input" name="seller_name" type="text" pInputText style="width: 100%;" formControlName="seller_name"> 
                    <label for="seller_name-input">{{ 'seller_name' | translate }}</label>
                </span>

                <span class="ui-float-label" style="margin-bottom: 20px;">
                    <input id="seller_address_1-input" name="seller_address_1" type="text" pInputText style="width: 100%;" formControlName="seller_address_1"> 
                    <label for="seller_address_1-input">{{ 'street_and_house' | translate }}</label>
                </span>

                <span class="ui-float-label" style="margin-bottom: 20px;">
                    <input id="seller_address_2-input" name="seller_address_2" type="text" pInputText style="width: 100%;" formControlName="seller_address_2"> 
                    <label for="seller_address_2-input">{{ 'postal_code_and_city' | translate }}</label>
                </span>

                <span class="ui-float-label" style="margin-bottom: 20px;">
                    <input id="invoice_issued_by-input" name="invoice_issued_by" type="text" pInputText style="width: 100%;" formControlName="invoice_issued_by"> 
                    <label for="invoice_issued_by-input">{{ 'invoice_issued_by' | translate }}</label>
                </span>

                <span class="ui-float-label" style="margin-bottom: 20px;">
                    <textarea id="enclosure-input" style="width: 100%;" [rows]="10"  pInputTextarea formControlName="enclosure" name="enclosure"></textarea>
                    <label for="enclosure-input">{{ 'bottom_enclosure' | translate }}</label>
                </span>

                <div *ngIf="isEditing == false"> 
                    <div class="ui-sm-6 ui-md-5 ui-lg-3 ui-xl-2">
                        <button (click)="startEditing()" pButton type="button" label="{{ 'edit' | translate }}" class="ui-button-info"  style="width: 100%;"></button>
                    </div>          
                </div>  
    
                <div class="ui-g" *ngIf="isEditing == true">  
                    <div class="ui-sm-6 ui-md-5 ui-lg-3 ui-xl-2">
                        <button pButton type="submit" [disabled]="!invoiceDetailsForm.valid" label="{{ 'save' | translate }}" class="ui-button-success" style="width: 100%;"></button>
                    </div>  
                    <div class="ui-sm-6 ui-md-5 ui-lg-3 ui-xl-2">
                        <button (click)="cancelEditing()" pButton type="button" label="{{ 'cancel' | translate }}" class="ui-button-warning" style="width: 100%;"></button>
                    </div>                 
                </div>
            </form>
 
        </div>
    </div>

</p-panel>